import type { TrackingProperties } from '@change-corgi/tracking-properties';

import { getNotKnownTrackingValue, isFbLoggedIn } from '#src/app/shared/utils/loginOrJoin';

export function initializeLoginSignupProps(facebook: {
	isConnected: boolean;
	authStatus: string | undefined;
}): TrackingProperties {
	return {
		connected_to_facebook: facebook.isConnected,
		connected_to_google: getNotKnownTrackingValue(),
		context: 'combined',
		email_domain: getNotKnownTrackingValue(),
		fb_logged_in: isFbLoggedIn(facebook.authStatus),
		google_logged_in: getNotKnownTrackingValue(),
		google_permissions: 'none',
		has_set_password: false,
		new_user: getNotKnownTrackingValue(),
	};
}
